import 'css-chunksrc/client/pages/projectPage/timeSheetPage/allocations/allocation/styles.scss';export default {
  "main": "_main_mvzul_1",
  "resource": "_resource_mvzul_13",
  "iconBox": "_iconBox_mvzul_23",
  "icon": "_icon_mvzul_23",
  "openedIcon": "_openedIcon_mvzul_40",
  "row": "_row_mvzul_44",
  "avatar": "_avatar_mvzul_52",
  "col": "_col_mvzul_57",
  "name": "_name_mvzul_66",
  "deactivated": "_deactivated_mvzul_72",
  "profession": "_profession_mvzul_79",
  "recordList": "_recordList_mvzul_84",
  "removedBadge": "_removedBadge_mvzul_88"
};